import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Page from '../../../enums/Page';
import VerificationProvider from '../../../enums/VerificationProvider';
import VerificationType from '../../../enums/VerificationType';
import {stopOrderProcessing} from '../../actions/site-actions';
import getPage from '../../page/getPage';
import getThreeDSecureData from '../../selectors/ThreeDSSelectors/getThreeDSecureData';
import CheckoutOverlay from '../CheckoutOverlay/CheckoutOverlay';
import ConditionalComponentWrapper from '../ConditionalComponentWrapper/ConditionalComponentWrapper';
import Chase3DSChallenge from './Chase/Chase3DSChallenge';
import Chase3DSRedirect from './Chase/Chase3DSRedirect';
import Checkoutcom3DSChallenge from './Checkoutcom/Checkoutcom3DSChallenge';
import Checkoutcom3DSRedirect from './Checkoutcom/Checkoutcom3DSRedirect';
import Nuvei3DSChallenge from './Nuvei/Nuvei3DSChallenge';
import ThreeDSecureRedirect from './ThreeDSecureRedirect';
import Worldpay3DSChallenge from './Worldpay/Worldpay3DSChallenge';

export function ThreeDSecureOverlay(props) {
  const getThreeDSChallenger = () => {
    if (props.threeDSecureData.verificationType === VerificationType.CHALLENGE) {
      switch (props.threeDSecureData.verificationProvider) {
        case VerificationProvider.WORLDPAY:
          return Worldpay3DSChallenge;
        case VerificationProvider.CHECKOUT_COM:
          return Checkoutcom3DSChallenge;
        case VerificationProvider.CHASE:
          return Chase3DSChallenge;
        case VerificationProvider.NUVEI:
          return Nuvei3DSChallenge;
        default:
          return null;
      }
    } else if (props.threeDSecureData.verificationType === VerificationType.REDIRECT) {
      switch (props.threeDSecureData.verificationProvider) {
        case VerificationProvider.CHECKOUT_COM:
          return Checkoutcom3DSRedirect;
        case VerificationProvider.CHASE:
          return Chase3DSRedirect;
        default:
          return ThreeDSecureRedirect;
      }
    }
    
    return ThreeDSecureRedirect;
  };
  
  const ThreeDSChallenger = getThreeDSChallenger();
  
  return (
    <ConditionalComponentWrapper
      shouldRenderWrapper={getPage() !== Page.PROCESSING}
      wrapper={children => (
        <CheckoutOverlay popup title="checkout.payment.3ds.security.check" exitCallback={props.stopOrderProcessing}>
          {children}
        </CheckoutOverlay>
      )}
    >
      <ThreeDSChallenger {...props.threeDSecureData} />
    </ConditionalComponentWrapper>
  );
}

ThreeDSecureOverlay.propTypes = {
  verificationType: PropTypes.string.isRequired,
  verificationProvider: PropTypes.string.isRequired,
  threeDSecureData: PropTypes.object,
  
  stopOrderProcessing: PropTypes.func,
};

const mapStateToProps = state => ({
  threeDSecureData: getThreeDSecureData(state),
});

export default connect(mapStateToProps, {stopOrderProcessing})(ThreeDSecureOverlay);
